var isabella = isabella || {};
isabella.villaAndCamplet = {
    debug: false,
    dealerData: {},
    init: function () {
        var jProduct = jQuery('.js-e-product'),
            strProductId = jProduct.data('productId'),
            strVariantId = jProduct.data('variantId'),
            strDataPropertyPath = [
                strProductId,
                'variantCombinations',
                strVariantId
            ].join('.');
        e4.util.debug(e4.data.get(strDataPropertyPath), isabella.villaAndCamplet.debug);
        if (e4.data.get(strDataPropertyPath) !== undefined) {
            e4.util.require.js(e4.settings.require.handlebars, function () {
                e4.handlebars.registerHelpers('counter');
                isabella.villaAndCamplet.handlebars.registerHelpers();
                e4.handlebars.registerTemplates('#js-e-handlebars-tmpl-villa-and-camplet-acc #js-e-handlebars-tmpl-villa-and-camplet-specs #js-e-handlebars-tmpl-villa-and-camplet-spec-acc #js-e-handlebars-tmpl-cart-b2c-dealer');
                isabella.villaAndCamplet.bindEvents();
                isabella.villaAndCamplet.dealers();
            });
        }
        isabella.villaAndCamplet.event = e4.util.registerEvents('setdetails pdfready', 'villaAndCamplet');
        jProduct.find('[data-toggle="popover"]').popover();
        
    },
    bindEvents: function () {
        var jGroupInputs = jQuery('.js-e-product-form').find('.js-e-product-form-variant-group-input');
        jGroupInputs.on('change', function (event) {
            isabella.villaAndCamplet.changeVariant(event.target);
        }).first().triggerHandler('change');
        jGroupInputs.first().one('focus', function (event) {
            var strProductId = jQuery(event.target.form).closest('.js-e-product').data('productId');
            isabella.villaAndCamplet.preloadImages(strProductId);
        });
        jQuery('.js-e-variant-button-reset').on('click', function (event) {
            event.target.form.reset();
            jQuery(event.target.form).find('.js-e-product-form-variant-group-input').first().triggerHandler('change');
        });
        jQuery('.js-e-product-form').on('input', '.js-isabella-quanitity', function (event) {
            var strVariantId = isabella.villaAndCamplet.getVariantId(jQuery(event.target).closest('form').get(0));
            isabella.villaAndCamplet.assessories.set();
            isabella.villaAndCamplet.updatePrice(strVariantId);
        }).on('change', '.js-e-camplet-product-related-form-input', function (event) {
            isabella.villaAndCamplet.setRelatedInputValue(event.target);
        });
        jQuery('.js-i-camplet-cart-dealer').on('change', '.js-i-camplet-cart-dealer-select', function (event) {
            var objSelectedDealer = isabella.villaAndCamplet.dealerData.filter(function (user) {
                return user.id === event.target.value;
            });
            if (objSelectedDealer.length === 1) {
                var dealer = objSelectedDealer[0];
                var dealerObj = {
                    EcomOrderDeliveryName: dealer.name,
                    EcomOrderDeliveryAddress: dealer.address,
                    EcomOrderDeliveryAddress2: dealer.address2,
                    EcomOrderDeliveryZip: dealer.zip,
                    EcomOrderDeliveryCity: dealer.city,
                    EcomOrderDeliveryCountry: dealer.country,
                    EcomOrderDeliveryCountryCode: dealer.countryCode,
                    EcomOrderDeliveryPhone: dealer.phone,
                    EcomOrderDeliveryMail: dealer.mail,
                    Company: dealer.company
                };
                e4.checkout.util.address.doMapping(dealerObj);
            }
        });

    },
    handlebars: {
        registerHelpers: function () {
            Handlebars.registerHelper('contains', function (v1, v2, options) {
                return (v1.indexOf(v2) > -1) ? options.fn(this) : options.inverse(this);
            });
        }
    },
    emptyContextCart: function (jForm) {
        var clearCart = jQuery.ajax({
            url: e4.settings.ecom.camplet.url,
            data: {
                OrderContext: 'Camplet',
                CartCmd: 'emptycart',
                Redirect: false
            }
        });
        jQuery.when(clearCart).then(function () {
            isabella.villaAndCamplet.addToContextCart(jForm);
        });


    },
    addToContextCart: function (jForm) {
        isabella.villaAndCamplet.ajax({
            url: e4.settings.ecom.camplet.url,
            data: jForm.serialize()
        }, function () {
            jQuery('#CampletB2CModal').modal();
        });
    },
    ajax: function (objAjaxSettings, fnCallback) {
        var jqXHR = jQuery.ajax(jQuery.extend({
            url: e4.settings.villa.acc.url,
            method: 'POST',
            dataType: 'json',
            cache: false
        }, objAjaxSettings));
        jqXHR.done(function (data) {
            if (typeof fnCallback === 'function') {
                fnCallback(data);
            }
        });
    },
    dealers: function () {
        isabella.villaAndCamplet.ajax({
            url: jQuery('html').data('area') + '/system/data/dealersearch-camplet',
            data: {
                Type: jQuery('.js-i-context-cart-product-form').data('dealerType'),
                countryCode: jQuery('.js-i-camplet-cart-dealer').data('countryCode')
            },
            method: 'GET'
        }, function (data) {
            isabella.villaAndCamplet.dealerData = data.users;
            jQuery('.js-i-camplet-cart-dealer').html(e4.handlebars.tmpl.cartB2cDealer(data));
        });
    },
    preloadImages: function (strProductId) {
        var arrVariantImages = [],
            fnLoadImages = function (arrImageSrc, intIndex) {
                intIndex = intIndex || 0;
                if (arrImageSrc && arrImageSrc.length > intIndex) {
                    var domImg = new Image();
                    domImg.onload = function () {
                        fnLoadImages(arrImageSrc, intIndex + 1);
                    };
                    domImg.onerror = function () {
                        fnLoadImages(arrImageSrc, intIndex + 1);
                    };
                    domImg.src = arrImageSrc[intIndex];
                }
            };
        jQuery.each(e4.data.get([
            strProductId,
            'variantCombinations'
        ].join('.')), function (strKey, objVariant) {
            if (objVariant.imagePrimary !== null) {
                arrVariantImages.push(objVariant.imagePrimary.small);
                arrVariantImages.push(objVariant.imagePrimary.large);
            }
            jQuery.each(objVariant.imageDetails, function (index, objImageUrl) {
                if (objImageUrl !== null) {
                    arrVariantImages.push(objImageUrl.small);
                    arrVariantImages.push(objImageUrl.large);
                }
            });
        });
        e4.util.debug(arrVariantImages, isabella.villaAndCamplet.debug);
        fnLoadImages(arrVariantImages);
    },
    setRelatedInputValue: function (domElement) {
        var jQuantity = jQuery(domElement).closest('.js-i-villa-and-camplet-variant-group-option').find('.js-isabella-quanitity');
        if (domElement.checked === true) {
            jQuantity.val(1);
        } else {
            jQuantity.val(0);
        }
        jQuantity.trigger('input');
    },
    changeVariant: function (domInput) {
        isabella.villaAndCamplet.updateSelectableOptionsInAllGroups(domInput);
        var jProductForm = jQuery(domInput.form),
            jProduct = jProductForm.closest('.js-e-product'),
            strProductId = jProduct.data('productId'),
            strVariantId = isabella.villaAndCamplet.getVariantId(domInput.form);
        e4.util.debug([
            'changeVariant isVariantIdValid?',
            strVariantId,
            isabella.villaAndCamplet.isVariantIdValid(strProductId, strVariantId)
        ], isabella.villaAndCamplet.debug);
        if (isabella.villaAndCamplet.isVariantIdValid(strProductId, strVariantId) === true) {
            isabella.villaAndCamplet.assessories.load(strProductId, strVariantId);
            isabella.villaAndCamplet.setVariantId(domInput.form, strVariantId);
            isabella.villaAndCamplet.setDetails(strVariantId);
        } else {
            isabella.villaAndCamplet.clearVariantId(domInput.form);
        }
    },
    isVariantIdValid: function (strProductId, strVariantId) {
        var strDataPropertyPath = [
            strProductId,
            'variantCombinations',
            strVariantId
        ].join('.');
        return e4.data.get(strDataPropertyPath) !== undefined;
    },
    getVariantId: function (domForm) {
        var arrGroupsSelected = [];
        jQuery(domForm).find('.js-e-product-form-variant-group').each(function (intIndex, domNode) {
            var jGroup = jQuery(domNode);
            arrGroupsSelected.push(isabella.villaAndCamplet.getGroupValue(jGroup));
        });
        return arrGroupsSelected.join('.');
    },
    setVariantId: function (domForm, strVariantId) {
        jQuery(domForm).find('input[name="VariantID0"]').val(strVariantId);
    },
    clearVariantId: function (domForm) {
        isabella.villaAndCamplet.setVariantId(domForm, '');
    },
    getSelectableOptionsForNextGroup: function (objVariantMap) {
        var objOptions = null;
        if (objVariantMap !== null && objVariantMap.options !== undefined) {
            objOptions = objVariantMap.options;
        }
        return objOptions;
    },
    getNextVariantMapLevel: function (strVariantOptionId, objVariantMap) {
        var objGroup = null;
        if (objVariantMap !== null && objVariantMap.options !== undefined && objVariantMap.options[strVariantOptionId] !== undefined) {
            objGroup = objVariantMap.options[strVariantOptionId];
        }
        return objGroup;
    },
    getNextGroupId: function (objVariantMap) {
        var strGroupId = '';
        if (objVariantMap !== null && objVariantMap.options !== undefined) {
            jQuery.each(objVariantMap.options, function (strKey, objValue) {
                strGroupId = objValue.groupId;
                // Return false to break jQuery.each loop.
                return false;
            });
        }
        return strGroupId;
    },
    getNextGroup: function (jGroup, jGroups) {
        var intNextGroupIndex = jGroups.index(jGroup) + 1;
        return jGroups.eq(intNextGroupIndex);
    },
    getGroupInputType: function (jGroup) {
        var strReturnValue,
            jGroupInput = jGroup.find('.js-e-product-form-variant-group-input');
        if (jGroupInput.length > 0) {
            strReturnValue = jGroupInput.get(0).type;
        }
        return strReturnValue;
    },
    getGroupOptions: function (jGroup) {
        var jReturnValue,
            strInputType = isabella.villaAndCamplet.getGroupInputType(jGroup),
            jGroupInput = jGroup.find('.js-e-product-form-variant-group-input');
        if (strInputType === 'select-one') {
            jReturnValue = jGroupInput.find('option').not('[value=""]');
        } else if (strInputType === 'radio') {
            jReturnValue = jGroupInput;
        }
        return jReturnValue;
    },
    getGroupValue: function (jGroup) {
        var strReturnValue,
            strInputType = isabella.villaAndCamplet.getGroupInputType(jGroup),
            jGroupInput = jGroup.find('.js-e-product-form-variant-group-input');
        if (strInputType === 'select-one') {
            strReturnValue = jGroupInput.val();
        } else if (strInputType === 'radio') {
            strReturnValue = jGroupInput.filter(':checked').val();
        }
        return strReturnValue;
    },
    selectOption: function (jOption) {
        var strInputType = isabella.villaAndCamplet.getGroupInputType(jOption.closest('.js-e-product-form-variant-group'));
        if (strInputType === 'select-one') {
            jOption.prop('selected', true);
        } else if (strInputType === 'radio') {
            jOption.prop('checked', true);
        }
    },
    deselectOption: function (jOption) {
        var strInputType = isabella.villaAndCamplet.getGroupInputType(jOption.closest('.js-e-product-form-variant-group'));
        if (strInputType === 'select-one') {
            jOption.closest('.js-e-product-form-variant-group-input').val('');
        } else if (strInputType === 'radio') {
            jOption.prop('checked', false);
        }
    },
    updateSelectableOptionsInAllGroups: function (domInput) {
        var jProduct = jQuery(domInput).closest('.js-e-product'),
            strProductId = jProduct.data('productId'),
            jGroups = jProduct.find('.js-e-product-form').find('.js-e-product-form-variant-group'),
            objVariantMap = e4.data.get([
                strProductId,
                'variantCombinationTree'
            ].join('.')),
            boolInvalidateNextGroup = false,
            boolAutoSelectFirstOptionIfGroupIsInvalidated = false,
            boolAutoSelectOptionIfOnlyOneOptionIsSelectable = false;
        jGroups.each(function (intIndex, domGroup) {
            var jGroup = jQuery(domGroup),
                strCurrentGroupVariantId = isabella.villaAndCamplet.getGroupValue(jGroup),
                jNextGroup = isabella.villaAndCamplet.getNextGroup(jGroup, jGroups),
                jNextGroupOptions = isabella.villaAndCamplet.getGroupOptions(jNextGroup),
                objSelectableOptionsForNextGroup = null;
            // Get current level options from variant map.
            objVariantMap = isabella.villaAndCamplet.getNextVariantMapLevel(strCurrentGroupVariantId, objVariantMap);
            // Get next level options from variant map.
            objSelectableOptionsForNextGroup = isabella.villaAndCamplet.getSelectableOptionsForNextGroup(objVariantMap);
            // Break loop if there is no next group.
            if (jNextGroup.length === 0) {
                return false; // Return false to break jQuery.each loop.
            }
            // Release all options in group if previous group was reset.
            if (boolInvalidateNextGroup === true) {
                // jNextGroupInput.prop( 'selectedIndex', 0 );
                jNextGroupOptions.prop('disabled', false);
            } else {
                jNextGroupOptions.prop('disabled', function () {
                    var jOption = jQuery(this),
                        strOptionValue = jOption.attr('value'),
                        isSelectable = objSelectableOptionsForNextGroup.hasOwnProperty(strOptionValue);
                    e4.util.debug([
                        jNextGroup.find('.js-e-product-form-variant-group-input').attr('name'),
                        strOptionValue,
                        objSelectableOptionsForNextGroup,
                        isSelectable
                    ], isabella.villaAndCamplet.debug);
                    // If current option already is selected and has been disabled, we need to reset the current
                    // select/input.
                    if (isSelectable === false && jOption.is(':checked') === true) {
                        isabella.villaAndCamplet.deselectOption(jOption);
                        boolInvalidateNextGroup = true;
                    }
                    // Return disabled state to filter function.
                    return !isSelectable;
                });
                // Get all options that is not disabled. If only one option is selectable we auto-select it
                var jNextGroupOptionsSelectable = jNextGroupOptions.not(':disabled');
                if (boolAutoSelectOptionIfOnlyOneOptionIsSelectable === true && jNextGroupOptionsSelectable.length === 1) {
                    isabella.villaAndCamplet.selectOption(jNextGroupOptionsSelectable);
                    boolInvalidateNextGroup = false;
                }
                if ((boolAutoSelectFirstOptionIfGroupIsInvalidated === true || isabella.villaAndCamplet.getGroupInputType(jNextGroup) === 'radio') && boolInvalidateNextGroup === true && jNextGroupOptionsSelectable.length > 0) {
                    isabella.villaAndCamplet.selectOption(jNextGroupOptionsSelectable.first());
                    boolInvalidateNextGroup = false;
                }
                if (isabella.villaAndCamplet.getGroupInputType(jNextGroup) === 'radio') {
                    jNextGroupOptions.closest('.js-i-villa-and-camplet-variant-group-option').attr('hidden', function () {
                        return jQuery(this).find('.js-e-product-form-variant-group-input').prop('disabled') === true;
                    });
                }
            }
        });
    },
    assessories: {
        load: function (strProductId, strVariantId) {
            isabella.villaAndCamplet.ajax({
                data: {
                    villaProductId: strProductId,
                    villaVariantId: strVariantId
                }
            }, function (data) {
                isabella.villaAndCamplet.assessories.build.list(data);
                isabella.villaAndCamplet.assessories.set();
                isabella.villaAndCamplet.updatePrice(strVariantId);

                jQuery('[data-rel="image-popover"]').popover({
                    html: true,
                    trigger: 'hover'
                });
            });
        },
        getSelected: function () {
            var arrAccessories = [];
            jQuery('.js-e-product-form').find('.js-isabella-quanitity').each(function (index, element) {
                var strQuantity = jQuery(element).val(),
                    strPrice = jQuery(element).data('price').toString(),
                    accRow = jQuery(element).closest('.js-isabella-product-villa-and-camplet-acc-row'),
                    accProductId = accRow.find('.js-acc-product-id').val(),
                    accProductName = accRow.find('.js-acc-product-name').val();
                if (strQuantity === '') {
                    strQuantity = 0;
                }
                if (parseInt(strQuantity) > 0) {
                    var intPrice = parseFloat(strPrice) * parseInt(strQuantity);
                    arrAccessories[accProductId] = {
                        id: accProductId,
                        name: accProductName,
                        price: parseFloat(strPrice) * parseInt(strQuantity),
                        formattedPrice: e4.util.formatJavascriptNumberToLocaleString(intPrice)
                    };
                } else {
                    delete arrAccessories[accProductId];
                }
            });
            return arrAccessories;
        },
        set: function () {
            var arrAccessories = isabella.villaAndCamplet.assessories.getSelected();
            isabella.villaAndCampletPdf.model.addons = arrAccessories;
            isabella.villaAndCamplet.assessories.build.specs(arrAccessories);
        },
        build: {
            list: function (data) {
                jQuery('.js-i-villa-and-camplet-acc').html(e4.handlebars.tmpl.villaAndCampletAcc(data));
            },
            specs: function (data) {
                jQuery('.js-e-product').find('.js-i-villa-and-camplet-specs-acc').html(e4.handlebars.tmpl.villaAndCampletSpecAcc(Object.values(data)));
            }
        }
    },
    getTotalPrice: function (intBasePrice) {
        var intTotalPrice = intBasePrice;
        jQuery('.js-e-product-form').find('.js-isabella-quanitity').each(function (index, element) {
            var strQuantity = jQuery(element).val(),
                strPrice = jQuery(element).data('price').toString();
            if (strQuantity === '') {
                strQuantity = 0;
            }
            intTotalPrice += (parseFloat(strPrice) * parseInt(strQuantity));
        });
        return intTotalPrice;
    },
    getVariantObj: function (strVariantId) {
        var jProduct = jQuery('.js-e-product'),
            strProductId = jProduct.data('productId'),
            strDataPropertyPath = [
                strProductId,
                'variantCombinations',
                strVariantId
            ].join('.'),
            jsonProduct = e4.data.get(strDataPropertyPath);
        return jsonProduct;
    },
    updatePrice: function (strVariantId) {
        var jProduct = jQuery('.js-e-product'),
            jsonProduct = isabella.villaAndCamplet.getVariantObj(strVariantId),
            isCampletProduct = jsonProduct.campletProduct,
            basePrice = isCampletProduct && jsonProduct.price.Price > 0 ? jsonProduct.price.Price : jsonProduct.bomPrice.Price,
            totalPrice = isabella.villaAndCamplet.getTotalPrice(basePrice);
        jProduct.find('.js-i-villa-and-camplet-price').find('.e-price-price').html(e4.util.formatJavascriptNumberToLocaleString(basePrice));
        jProduct.find('.js-i-villa-and-camplet-total-price').find('.e-price-price').html(e4.util.formatJavascriptNumberToLocaleString(totalPrice));
    },
    setDetails: function (strVariantId) {
        var jProduct = jQuery('.js-e-product'),
            jsonProduct = isabella.villaAndCamplet.getVariantObj(strVariantId);
        jQuery('.js-isabella-villa-and-camplet-pdf').trigger(isabella.villaAndCamplet.event.setdetails, strVariantId);
        e4.util.debug([
            'price',
            e4.util.formatJavascriptNumberToLocaleString(jsonProduct.price.Price)
        ], isabella.villaAndCamplet.debug);
        if (jsonProduct !== undefined) {
            if (jsonProduct.imagePrimary !== null) {
                jProduct.find('.js-i-villa-and-camplet-image-large').css('backgroundImage', 'url(' + jsonProduct.imagePrimary.large + ')');
                jProduct.find('.js-i-villa-and-camplet-image-medium').attr('src', jsonProduct.imagePrimary.medium);
            } else {
                jProduct.find('.js-i-villa-and-camplet-image-large').css('backgroundImage', 'url()');
                jProduct.find('.js-i-villa-and-camplet-image-medium').attr('src', '');
            }

            jProduct.find('.js-i-villa-and-camplet-name').html(jsonProduct.name);
            jProduct.find('.js-i-villa-and-camplet-number').html(jsonProduct.number);
            isabella.villaAndCamplet.updatePrice(strVariantId);
            jProduct.find('.js-i-villa-and-camplet-specs').html(e4.handlebars.tmpl.villaAndCampletSpecs(jsonProduct));
        }
    }
};
